import PropTypes from 'prop-types';
import React from 'react';
import ScrollIntoViewElement from '@99designs/react-components/components/ScrollIntoViewElement';
import Avatar from '@99designs/react-components/components/Avatar';
import CommentField from '@99designs/react-components/components/CommentField';
import { FormattedMessage } from 'react-intl';

export default class CommentForm extends React.Component {
    constructor(props) {
        super(props);
        this.errorMessage = this.errorMessage.bind(this);
    }
    errorMessage() {
        if (!this.props.showErrorMessage) return null;

        return (
            <div>
                <FormattedMessage id="comment_submit_failure" />
            </div>
        );
    }
    render() {
        const submitButtonLabel = <span className="icon icon--sent-1" />;

        return (
            <ScrollIntoViewElement
                scrollingContainer={this.props.scrollingContainer}
                isEnabled={true}
            >
                {this.errorMessage()}
                <div className="comment-submit" onClick={this.props.onClick}>
                    {this.props.author && (
                        <div className="comment-submit__avatar">
                            <Avatar
                                user={this.props.author}
                                variations={['block', 'extra-small']}
                            />
                        </div>
                    )}
                    <div className="comment-submit__form">
                        <CommentField
                            placeholder={this.context.intl.formatMessage({
                                id: 'comment_form_placeholder',
                            })}
                            layout={this.props.isVertical ? 'vertical' : 'horizontal'}
                            isAutoFocus={this.props.isAutoFocus}
                            submitButtonLabel={submitButtonLabel}
                            submitButtonTooltip={this.context.intl.formatMessage({
                                id: 'send_message_tooltip',
                            })}
                            cancelButtonLabel={this.context.intl.formatMessage({
                                id: 'comment_cancel',
                            })}
                            textValue={this.props.comment && this.props.comment.message}
                            hasCancelButton={this.props.hasCancelButton}
                            onCancel={this.props.onCancel}
                            onSubmit={this.props.onSubmit}
                            onKeyDown={this.props.onKeyDown}
                            onKeyUp={this.props.onKeyUp}
                            criticalError={this.props.criticalError}
                            hasFieldError={this.props.showErrorMessage}
                        />
                    </div>
                </div>
            </ScrollIntoViewElement>
        );
    }
}

CommentForm.contextTypes = {
    intl: PropTypes.object,
};

CommentForm.propTypes = {
    author: PropTypes.object,
    comment: PropTypes.object,
    isVertical: PropTypes.bool,
    isAutoFocus: PropTypes.bool,
    hasCancelButton: PropTypes.bool,
    onCancel: PropTypes.func,
    onClick: PropTypes.func,
    onSubmit: PropTypes.func,
    onKeyDown: PropTypes.func,
    onKeyUp: PropTypes.func,
    scrollingContainer: PropTypes.object,
};

CommentForm.defaultProps = {
    hasCancelButton: false,
    isAutoFocus: false,
    isVertical: false,
    onCancel() {},
    onClick() {},
    onSubmit() {},
    onKeyDown() {},
    onKeyUp() {},
};



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/CommentForm.jsx